<template>
  <div class="breadcrumbs-container">
    <div class="breadcrumbs">
      <div
        class="breadcrumb-item"
        v-for="breadcrumb in breadCrumbs"
        :key="'breadcrumb-' + breadcrumb.name.toLowerCase()"
      >
        <router-link :to="breadcrumb.url">{{ breadcrumb.name }}</router-link>
      </div>
    </div>
    <div class="action-labels" v-show="showBreadcrumbActionsLabel">
      <div class="action-label action-label-customization">
        COLORS & CUSTOMIZATION
      </div>
      <div class="action-label action-label-locker">LOCKER</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ShowroomBreadcrumbs",
  computed: {
    ...mapState("showroom", ["breadCrumbs"]),

    showBreadcrumbActionsLabel() {
      return this.breadCrumbs[0]?.name === "< START"; //xd
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .breadcrumbs-container {
    max-width: 1440px;
    margin: 5px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .breadcrumbs {
      display: flex;
      justify-content: start;
      align-items: center;
      padding-left: 20px;
      width: 50%;
      .breadcrumb-item {
        a {
          border-radius: 5px;
          font-size: 14px;
          padding: 0.25rem 0;
          line-height: 130%;
          color: $grey-dark;
          text-transform: uppercase;
          transition: all 0.2s;

          &:hover {
            background-color: $grey-lightest;
            text-decoration: underline !important;
          }
        }
      }
    }
    .action-labels {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 50%;
      .action-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        line-height: 130%;
        color: $grey-dark;
        &.action-label-customization {
          max-width: 550px;
          width: 75%;
        }
        &.action-label-locker {
          width: 25%;
          max-width: 165px;
        }
      }
    }
  }
}
</style>
